// src/pages/LoginPage.tsx

import React from "react";
import {
    Box,
    Heading,
    Text,
    Button,
    Flex,
    useColorModeValue,
    Spinner,
} from "@chakra-ui/react";
import { useAuth } from "../hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";

const LoginPage: React.FC = () => {
    const { login, isAuthenticated, isLoading, error, getFullName } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = (location.state as any)?.from?.pathname || "/";

    React.useEffect(() => {
        if (isAuthenticated) {
            navigate(from, { replace: true });
        }
    }, [isAuthenticated, navigate, from]);

    const pageBg = useColorModeValue("gray.50", "gray.800");
    const cardBg = useColorModeValue("white", "gray.700");

    if (isLoading) {
        return (
            <Flex minH="100vh" align="center" justify="center" bg={pageBg}>
                <Spinner size="xl" color="purple.500" />
            </Flex>
        );
    }

    return (
        <Flex minH="100vh" align="center" justify="center" bg={pageBg} p={4}>
            <Box bg={cardBg} p={8} rounded="lg" shadow="lg" maxW="md" w="full">
                {!isAuthenticated && (
                    <>
                        <Heading mb={4} textAlign="center" color="purple.600" size="lg">
                            Connexion
                        </Heading>

                        {error && (
                            <Box mb={4} p={3} bg="red.50" rounded="md">
                                <Text fontWeight="bold" color="red.600">
                                    Erreur d'authentification
                                </Text>
                                <Text mt={1} color="red.600">
                                    {error}
                                </Text>
                                <Button
                                    mt={4}
                                    size="sm"
                                    colorScheme="purple"
                                    onClick={() => window.location.reload()}
                                >
                                    Réessayer
                                </Button>
                            </Box>
                        )}

                        <Text mb={6} textAlign="center">
                            Veuillez vous connecter pour accéder à l'application.
                        </Text>
                        <Button colorScheme="purple" size="lg" w="full" onClick={login}>
                            Se connecter
                        </Button>
                    </>
                )}

                {isAuthenticated && (
                    <>
                        <Heading mb={4} textAlign="center" color="purple.600" size="lg">
                            Bienvenue, {getFullName()}
                        </Heading>
                        <Text mb={6} textAlign="center">
                            Vous êtes connecté avec succès.
                        </Text>
                        <Button
                            colorScheme="purple"
                            size="lg"
                            w="full"
                            onClick={() => navigate(from)}
                        >
                            Continuer
                        </Button>
                    </>
                )}
            </Box>
        </Flex>
    );
};

export default LoginPage;